<div *ngFor="let table of arrTable" class="elementinnerholder">
    <a name="delimiter_{{ table.webpagedefinitionitemid }}" id="delimiter_{{ table.webpagedefinitionitemid }}" class="delimiter">
    </a>
</div>